export enum TooltipPosition {
    Left,
    Right,
    Top,
    Bottom,
    Center,
}
